import {Component, Input, OnInit} from '@angular/core';
import {Button} from '../../../shared/button/button.component';
import {ButtonDispenseMixInterface, ButtonDispenseMixStatesInterface} from '../../../interfaces/simulator-entry';

@Component({
  selector: 'app-button-dispense-mix-entry',
  templateUrl: './button-dispense-mix-entry.component.html',
  styleUrls: ['./button-dispense-mix-entry.component.sass']
})
export class ButtonDispenseMixEntryComponent extends Button implements OnInit {

  @Input() data: ButtonDispenseMixInterface;
  public states;

  ngOnInit() {
    this.states = ButtonDispenseMixStatesInterface;
  }

}
